<!-- Cabecera -->
<app-header-colectivos [menuAbierto]="menuAbierto" (reportarEstadoMenu)="actualizarEstadoMenu($event)">
</app-header-colectivos>

<!-- Contenido -->
<router-outlet></router-outlet>
